import * as React from 'react';
import * as autoBind from 'react-autobind';
import * as classNames from 'classnames';
import Strings from '../../globals/Strings';
import FeedbackUserService from '../../services/FeedbackUserService/FeedbackUserService';
import {AlertModal, TscButtonType} from '@techsmith/tsc-cloud-style-guide';

export default class SelfIdentifiedCommentingAs extends React.Component<SelfIdentifiedCommentingAsProps, SelfIdentifiedCommentingAsState> {
   readonly state: SelfIdentifiedCommentingAsState = {showAlert: false};

   constructor(props: SelfIdentifiedCommentingAsProps) {
      super(props);
      autoBind(this);
   }

   onConfirm() {
      FeedbackUserService.forgetSelfIdentifiedUser();
      this.setState({showAlert: false});
   }

   onCancel() {
      this.setState({showAlert: false});
   }

   showAlert() {
      this.setState({showAlert: true});
   }

   render() {
      const {isInline, userName} = this.props;
      const strings = Strings.labels.selfIdentifiedCommentingAs;
      const classes = classNames('self-identified-commenting-as', isInline ? 'self-identified-commenting-as-inline' : 'self-identified-commenting-as-bottom');
      const commentingAs = strings.commentingAs.replace('{param0}', userName);

      const alertModal = <AlertModal title={strings.changeReviewer}
                                     onClose={this.onCancel}
                                     closeContent={strings.cancel}
                                     onConfirm={this.onConfirm}
                                     confirmContent={strings.changeReviewer}
                                     confirmButtonType={TscButtonType.destructive}
                                     onDismiss={this.onCancel}
                                     dismissContent={strings.cancel}
                                     testId="change-reviewer-alert"
                                     modalWidth="23rem">
         <div className="self-identified-commenting-as-alert">
            {strings.alertText.replace('{param0}', userName)}
         </div>
      </AlertModal>;

      return (
         <div className={classes}>
            <div className="self-identified-commenting-as-text">
               {commentingAs}
            </div>
            <button className="self-identified-commenting-as-link" onClick={this.showAlert}>{strings.changeReviewer}</button>
            {this.state.showAlert && alertModal}
         </div>
      );
   }
}

export interface SelfIdentifiedCommentingAsState {
   showAlert: boolean;
}

export interface SelfIdentifiedCommentingAsProps {
   isInline: boolean;
   userName: string;
}
